import PropTypes from "prop-types";
import React, { Component } from "react";

class Logout extends Component {
    constructor(){
        super();
    }

    componentDidMount(){
        this.props.userLogout();        
    }

    render(){
        return (<div/>);
    }
}

Logout.propTypes = {
    userLogout: PropTypes.func.isRequired
};

export default Logout;